import {Component, CUSTOM_ELEMENTS_SCHEMA, OnInit, output, signal} from '@angular/core';
import {NotificationItem} from '../notification-item/notification-item';
import {NotificationDto} from '../../../dto/notification-dto';
import {Notification} from '../../../service/notification';
import {environment} from '../../../../environments/environment';
import {Avatar} from '../../shared/avatar/avatar';
import {Alert, AlertService, AlertType} from '@innovactions/frontend-library';

@Component({
  selector: 'app-notifications-overview',
  imports: [NotificationItem, Avatar],
  templateUrl: './notifications-overview.html',
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class NotificationsOverview implements OnInit {

  protected notifications = signal<NotificationDto[]>([]);
  protected totalUnreadNotifications = signal<number>(0);
  private readonly itemsPerPage = environment.itemsPerPage;

  unreadNotifications = output<number>();

  constructor(private readonly notificationService: Notification, private readonly alertService: AlertService) {
  }

  ngOnInit() {
    this.retrieveNotifications(0);
  }

  protected markAllAsRead() {
    this.notificationService.markNotificationsAsRead().subscribe({
      next: () => {
        this.totalUnreadNotifications.set(0);
        this.unreadNotifications.emit(0);
      },
      error: () => {
        this.alertService.createAlert(new Alert(AlertType.ERROR, "Markeren als gelezen mislukt", "Het is niet gelukt om alle notificaties te markeren als gelezen", false));
      }
    });
  }

  private retrieveNotifications(page: number) {
    this.notificationService.retrieveNotifications(page, this.itemsPerPage, ['id', 'rcpt', 'subject', 'body', 'createdAt', 'totalUnreadNotifications', 'notificationType', 'context']).subscribe({
      next: (response) => {
        if (response && response.length > 0) {
          this.notifications.set(response);
          this.totalUnreadNotifications.set(response[0].totalUnreadNotifications);
          this.unreadNotifications.emit(response[0].totalUnreadNotifications);
        }
      }
    });
  }
}
